import React, { ReactElement, useState } from 'react';

import type { ReviewItemMessageInterface } from 'components/review/review.interface';
import ReviewItemMessage from 'components/review/review-item-messages/review-item-message';
import Button from 'atomic/button/button';

import './review-item-messages.scss';

const MESSAGES_LIST_LIMIT = 1;

interface ReviewItemMessagesProps {
    items: ReviewItemMessageInterface[];
}

const ReviewItemMessages: React.FC<ReviewItemMessagesProps> = ({ items }): ReactElement => {
    const [showMoreButton, setShowMoreButton] = useState(items.length > MESSAGES_LIST_LIMIT);

    const elements = items.map((item, index) => (
        <ReviewItemMessage key={item.id} hidden={showMoreButton && index >= MESSAGES_LIST_LIMIT} {...item} />
    ));

    const moreButton = showMoreButton
        ? (
            <div className="review-item__messages-more">
                <Button onClick={(): void => setShowMoreButton(false)} uppercase={true}>
                    Zobacz więcej
                </Button>
            </div>
        )
        : null;

    return (
        <div className="review-item__messages">
            <div className="review-item__messages-list">
                {elements}
            </div>
            {moreButton}
        </div>
    );
};

export default ReviewItemMessages;
